module.exports = __webpack_public_path__ + "img/509.operating_instructions.1a882b35.svg";